<template>
  <CCard>
    <CCardHeader>
      <h2>Edit Gym</h2>
    </CCardHeader>

    <CCardBody>
      <form
        autocomplete="off"
        @submit.prevent="saveGym"
      >
        <CInput
          v-model="gym.name"
          label="Name"
          placeholder="Gym Name"
          :add-input-classes="{'is-invalid': hasError('gym_name')}"
          :invalid-feedback="getError('gym_name')"
        />

        <CInput
          v-model="gym.email"
          label="Email"
          type="email"
          placeholder="Gym Email"
          :add-input-classes="{'is-invalid': hasError('email')}"
          :invalid-feedback="getError('email')"
        />

        <div class="mt-3">
          <CButton
            type="submit"
            color="primary"
          >
            Save
          </CButton>
          <CButton
            type="button"
            color="secondary"
            class="ml-2"
            @click="goBack"
          >
            Cancel
          </CButton>
        </div>
      </form>

      <div
        v-if="loading"
        class="mt-3 text-center"
      >
        <CSpinner
          color="primary"
          grow
          style="width:2rem;height:2rem;"
        />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import hasApiValidation from "@/mixins/hasApiValidation";

export default {
  name: "EditGym",
  mixins: [hasApiValidation],
  data() {
    return {
      gym: {
        id: null,
        name: '',
        email: ''
      },
      loading: false
    };
  },
  mounted() {
    this.fetchGym();
  },
  methods: {
    fetchGym() {
      const gymId = this.$route.params.id;
      if (!gymId) return;

      this.loading = true;
      this.$http.get(`/gym/${gymId}`)
        .then(({ data }) => {
          // Mapear respuesta del backend a nuestro formulario
          this.gym = {
            id: data.id,
            name: data.name,
            email: data.email
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saveGym() {
      this.setErrors({});
      this.$http.put(`/gym/${this.gym.id}`, {
        gym_name: this.gym.name, // ⚠️ ahora coincide con el backend
        email: this.gym.email
      })
      .then(() => {
        this.$toast.success("Gym updated!");
        this.$router.push({ name: "Gyms" }); // asegurarte que esta es la ruta de la lista
      })
      .catch(({ response }) => {
        this.$toast.error(response.data.message || "Failed to update gym.");
        if (response.data.errors) {
          this.setErrors(response.data.errors);
        }
      });
    },

    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.mt-3 { margin-top: 1rem; }
.ml-2 { margin-left: 0.5rem; }
</style>
